import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Input, Title, Button, Text } from 'ui';
import { sendPasswordReset } from 'api';
import logo from '../assets/logo-white.png'

export default function ResetPassword(props) {

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState({});
  const [error, setError] = useState("");


  async function submit() {
    if(loading) {
      return;
    }
    setError("");
    if(!value.email) {
      setError("Please enter your email address.");
      return;
    }
    try {
      setLoading(true);
      await sendPasswordReset(value.email);
    }
    catch(error) {
      setLoading(false);
      setError(error.message);
      return;
    }

    setLoading(false);
    history.push("password-reset-sent");
  }

  return (
    <div className="auth auth-login">
      <Form onSubmit={submit} value={value} onChange={setValue} className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">Enter your email</Title>
        <div style={{paddingBottom:16}}>
          <Text white>Enter your email below and we'll send you an email with a link to change your password.</Text>
        </div>
        <Input name="email" label="Email Address" white className="auth-input"/>
        <Button block small tertiary white className="auth-link" label="Login here." to="login"/>
        <Button block small tertiary white className="auth-link" label="Not a member? Register here." to="register"/>
        <Text block color="red" bold small>{error}</Text>
        <Button className="auth-button" white label={loading ? "Sending..." : "Send"} onClick={submit}/>
      </Form>
    </div>
  );
}